<template>
  <el-dialog :visible="visible"
             @close="close"
             width="620px">
    <h2>Prawidłowo wypełniony formularz</h2>
    <p class="h2-subtitle" v-required-mark>Wymagane pola są oznaczone</p>
    <topup-form :params="exampleData" :disabled="true" />
    <button type="button" @click="close" class="btn">Zamknij</button>
  </el-dialog>
</template>

<script>
import TopupForm from '@/pge/components/Topup/Form'

export default {
  name: 'TopupGuideExample',
  components: {
    TopupForm
  },
  props: ['visible'],
  data: () => {
    return {
      exampleData: {
        code: '1234 5678 9012 3456',
        amount: '150',
        email: 'adres@email.pl',
        phone: '123 456 789',
        agreement: true,
        agreeShare: true,
        agreeContact: true
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    }
  }
}
</script>
